module.exports = __webpack_public_path__ + "static/media/speedweaver.4e12eee0.svg";